import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import Modal from "../../Generic/Modal";

import useStyles from "./styles";

interface DeleteConfirmationProps {
  showDeleteConfirmation: boolean;
  setShowDeleteConfirmation: (showDeleteConfirmationDialog: boolean) => void;
  deleteAction: () => void;
}

const DeleteConfirmation = ({
  showDeleteConfirmation,
  setShowDeleteConfirmation,
  deleteAction
}: DeleteConfirmationProps) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Modal
      className={classes.deleteDialog}
      open={showDeleteConfirmation}
      title={t("deleteConfirmation")}
      handleClose={() => setShowDeleteConfirmation(false)}
      showActionButtons
      actionButtonProps={{
        onSave: deleteAction,
        textSave: t("delete")
      }}
    >
      <Box display="flex" alignItems="center">
        <span>{t("areYouSureYouWantToRemoveThisItem")}</span>
      </Box>
    </Modal>
  );
};

export default DeleteConfirmation;
